import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-plus",
  "use": "icon-s-plus-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-plus\"><path fill-rule=\"evenodd\" d=\"M12 12 12 21 10 21 10 12 1 12 1 10 10 10 10 1 12 1 12 10 21 10 21 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol